<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper" @click="$emit('closeModal')">
        <div class="row">
          <div class="col-xs-0 col-sm-0 col-md-1 col-lg-2"></div>
          <div class="col-xs-12 col-sm-12 col-md-10 col-lg-8">
            <div class="modal-container" @click.stop>

              <div class="modal-header row" style="justify-content: flex-end;">
                <!-- <div class="col-6">
                  <button type="button" class="btn btn-sm btn-outline-primary" @click="$emit('newUserBack')">< Back</button>
                </div> -->
                <div class="col">
                  <button type="button" class="close" @click="$emit('closeModal')">
                      <span aria-hidden="true">&times;</span>
                  </button>
                </div>
              </div>

              <div class="modal-body">
                <h2 class="title">Buat Mobil Pelanggan Baru</h2>
                <form>
                  <div class="row row-space">
                    <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                      <div class="input-group">
                        <label class="label">Nama Pelanggan<span style="color: red;">*</span></label>
                        <MultiSelect
                          v-model="form.customer_id"
                          :options="options.customer.map(x => x.id)"
                          :custom-label="opt => options.customer.find(x => x.id == opt).name"
                          :searchable="true"
                          :close-on-select="true"
                          :multiple="false"
                          :allow-empty="false"
                          placeholder="Pilih Nama Pelanggan"
                        ></MultiSelect>
                      </div>
                    </div>
                    <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                      <div class="input-group">
                        <label class="label">Nomor Polisi<span style="color: red;">*</span></label>
                        <input class="input--style-4" type="text" v-model="form.registration" placeholder="Ketik Nomor Polisi">
                      </div>
                    </div>
                  </div>
                  <div class="row row-space">
                    <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                      <div class="input-group">
                        <label class="label">Tipe Mobil<span style="color: red;">*</span></label>
                        <MultiSelect
                          v-model="form.car_id"
                          :options="options.model.map(x => x.id)"
                          :custom-label="opt => options.model.find(x => x.id == opt).name"
                          :searchable="true"
                          :close-on-select="true"
                          :multiple="false"
                          :allow-empty="false"
                          placeholder="Pilih Tipe Mobil"
                        ></MultiSelect>
                      </div>
                    </div>
                    <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                      <div class="input-group">
                        <label class="label">Warna Mobil<span style="color: red;">*</span></label>
                        <MultiSelect
                          v-model="form.car_color_id"
                          :options="options.color.map(x => x.id)"
                          :custom-label="opt => options.color.find(x => x.id == opt).name"
                          :searchable="true"
                          :close-on-select="true"
                          :multiple="false"
                          :allow-empty="false"
                          placeholder="Pilih Warna Mobil"
                        ></MultiSelect>
                      </div>
                    </div>
                  </div>
                  <div class="row row-space">
                    <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                      <div class="input-group">
                        <label class="label">Nomor Rangka<span style="color: red;">*</span></label>
                        <input class="input--style-4" type="text" v-model="form.chassis_number" placeholder="Ketik Nomor Rangka">
                      </div>
                    </div>
                    <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                      <div class="input-group">
                        <label class="label">Nomor Mesin<span style="color: red;">*</span></label>
                        <input class="input--style-4" type="text" v-model="form.engine_number" placeholder="Ketik Nomor Mesin">
                      </div>
                    </div>
                  </div>
                  <div class="row row-space">
                    <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                      <div class="input-group">
                        <label class="label">Tahun Pembuatan Mobil<span style="color: red;">*</span></label>
                        <MultiSelect
                          v-model="form.year"
                          :options="options.year"
                          :searchable="true"
                          :close-on-select="true"
                          :multiple="false"
                          :allow-empty="false"
                          placeholder="Pilih Tahun Pembuatan"
                        ></MultiSelect>
                      </div>
                    </div>
                    <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                      <div class="input-group">
                        <label class="label">Kilometer Sekarang (KM)<span style="color: red;">*</span></label>
                        <input class="input--style-4" type="text" v-model="form.current_km" placeholder="Ketik Kilometer Sekarang">
                      </div>
                    </div>
                  </div>
                  <div class="row row-space">
                    <div class="col-12">
                      <div class="input-group">
                        <label class="label">Gambar STNK<span style="color: red;">*</span></label>
                        <input
                          class="input--style-4"
                          type="file"
                          id="file"
                          ref="file"
                          v-on:change="handleFileUpload()"
                          accept="image/x-png, image/jpeg, image/jpg">
                          <p style="color:red" v-if="imageError.show">{{ imageError.message }}</p>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col mt-5" style="text-align: center">
                      <button type="button" class="btn btn-outline-danger" style="font-size:140%" @click="$emit('closeModal')">Kembali</button>
                      <button type="button" class="btn btn-primary ml-5" style="font-size:150%" @click="submitForm()">Buat</button>
                    </div>
                  </div>
                </form>
              </div>
          </div>
        </div>
      </div>
      <div class="col-xs-0 col-sm-0 col-md-1 col-lg-2"></div>
    </div>
  </div>
</transition>
</template>

<script>
  import MultiSelect from 'vue-multiselect';
  import FormData from 'form-data'

  export default {
    data () {
      return{
        options : this.$store.getters.getFilterOptions,
        imageError : {
          show : false,
          message : '',
        },
        form : {
          customer_id : null,
          registration : '',
          car_id : null,
          car_color_id : null,
          chassis_number : '',
          engine_number : '',
          year : null,
          last_km : 0,
          current_km : '',
          image : '',
        }
      }
    },
    components:{
      MultiSelect,
    },
    mounted () {

    },
    watch : {
      
    },
    methods : {
      setImageError(message){
        this.imageError.show = true;
        console.log('b');
        this.imageError.message = message
      },
      handleFileUpload(){
        this.imageError.show = false;
        if(this.$refs.file.files[0]){
          if(this.$refs.file.files[0].size <= 0){
            this.setImageError('Gambar tidak dapat di-kosongkan!')
          } else if(this.$refs.file.files[0].size > 8000000){
            this.setImageError('Gambar tidak dapat melibihi 8MB!')
          } else {
            this.form.image = this.$refs.file.files[0];
          }
        }
      },
      validateForm(){
        var valid = true;
        var error = [];

        if(this.form.customer_id == '' || this.form.customer_id == null){//Nama Pelanggan [Required]
          valid = false;
          error.push('Nama pelanggan wajib terisi!');
        }

        if(this.form.registration == '' || this.form.registration == null){//Nomor Polisi [Required]
          valid = false;
          error.push('Nomor polisi wajib terisi!');
        }

        if(this.form.car_id == '' || this.form.car_id == null){//Tipe Mobil [Required]
          valid = false;
          error.push('Tipe mobil wajib terisi!');
        }

        if(this.form.car_color_id == '' || this.form.car_color_id == null){//Tipe Mobil [Required]
          valid = false;
          error.push('Warna mobil wajib terisi!');
        }

        if(this.form.chassis_number == '' || this.form.chassis_number == null){//Nomor Rangka [Required]
          valid = false;
          error.push('Nomor rangka wajib terisi!');
        } else if (this.form.chassis_number.toString().length > 17) {
          valid = false;
          error.push('Nomor rangka tidak dapat melebih 17 nomor!');
        }

        if(this.form.engine_number == '' || this.form.engine_number == null){//Nomor Mesin [Required]
          valid = false;
          error.push('Nomor mesin wajib terisi!');
        }

        if(this.form.year == '' || this.form.year == null){//Tahun Pembuatan Mobil [Required]
          valid = false;
          error.push('Tahun pembuatan mobil wajib terisi!');
        }

        if(this.form.current_km == '' || this.form.current_km == null){//Kilometer Sekarang (KM) [Required]
          valid = false;
          error.push('Kilometer sekarang wajib terisi!');
        } else if (isNaN(this.form.current_km)){
          valid = false;
          error.push('Kilometer hanya dapat terisi dengan nomor!');
        }

        if(this.form.image == '' || this.form.image == null){//Gambar STNK [Required]
          valid = false;
          error.push('Gambar STNK wajib di-unggah!');
        }

        if(!valid) this.$store.dispatch('triggerAlert', [false, error]);
        else return valid;
      },
      async submitForm(){
        let vm = this;
        if(vm.validateForm()){
          //Create new form data object
          let formData = new FormData();

          //Convert JSON to Form Data
          for(var key in this.form) formData.append(key, this.form[key]);

          this.$http.post('/api/v1/masterData/customer_car', formData, {headers: {'Content-Type': 'multipart/form-data'}})
          .then((resp)=>{
            this.$store.dispatch('triggerAlert', [true, [`Mobil pelanggan telah berhasil dibuat`]]);
            this.$emit('updateTable');
            this.$emit('closeModal');
          })
          .catch((err)=>{
            console.log(err);
            this.$store.dispatch('triggerAlert', [false, [err.response.data.data]]);
          })
        }
      },
    }
  }
</script>

<style scoped>

/* ==========================================================================
#FORM made by Colorlib (https://colorlib.com)
========================================================================== */
input {
  outline: none;
  margin: 0;
  border: none;
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  box-shadow: none;
  width: 100%;
  font-size: 14px;
  font-family: inherit;
}

.input--style-4 {
  line-height: 50px;
  background: #fafafa;
  -webkit-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
  -moz-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
  box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  border-radius: 5px;
  padding: 0 20px;
  font-size: 16px;
  color: #666;
  -webkit-transition: all 0.4s ease;
  -o-transition: all 0.4s ease;
  -moz-transition: all 0.4s ease;
  transition: all 0.4s ease;
}

.input--style-4::-webkit-input-placeholder {
  /* WebKit, Blink, Edge */
  color: #666;
}

.input--style-4:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  color: #666;
  opacity: 1;
}

.input--style-4::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  color: #666;
  opacity: 1;
}

.input--style-4:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: #666;
}

.input--style-4:-ms-input-placeholder {
  /* Microsoft Edge */
  color: #666;
}

.label {
  font-size: 16px;
  color: #555;
  text-transform: capitalize;
  display: block;
  margin-bottom: 5px;
}

.radio-container {
  display: inline-block;
  position: relative;
  padding-left: 30px;
  cursor: pointer;
  font-size: 16px;
  color: #666;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.radio-container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}

.radio-container input:checked ~ .checkmark {
  background-color: #e5e5e5;
}

.radio-container input:checked ~ .checkmark:after {
  display: block;
}

.radio-container .checkmark:after {
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  -moz-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  -o-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  width: 12px;
  height: 12px;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  border-radius: 50%;
  background: #57b846;
}

.checkmark {
  position: absolute;
  top: 50%;
  -webkit-transform: translateY(-50%);
  -moz-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  -o-transform: translateY(-50%);
  transform: translateY(-50%);
  left: 0;
  height: 20px;
  width: 20px;
  background-color: #e5e5e5;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  border-radius: 50%;
  -webkit-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
  -moz-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
  box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
}

.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

.input-group {
  position: relative;
  /* margin-bottom: 22px; */
  padding:20px;
}

.input-group-icon {
  position: relative;
}

.input-icon {
  position: absolute;
  font-size: 18px;
  color: #999;
  right: 18px;
  top: 50%;
  -webkit-transform: translateY(-50%);
  -moz-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  -o-transform: translateY(-50%);
  transform: translateY(-50%);
  cursor: pointer;
}

/* ==========================================================================
    #TITLE made by Colorlib (https://colorlib.com)
    ========================================================================== */
.title {
  font-size: 40px;
  color: #525252;
  margin-bottom: 40px;
  text-align: center;
}
</style>
